import React from 'react'
import PropTypes from 'prop-types'

const Button = ({ 
  children, 
  component, 
  variant = 'primary',
  size = 'md',
  href,
  ...props 
}) => {
  const El = href ? 'a' : component || 'button'

  return (
    <El href={href} type={!href ? 'button' : undefined} {...props}>
      {children}
    </El>
  )
}

Button.propTypes = {
  children: PropTypes.node,
  component: PropTypes.elementType,
  variant: PropTypes.oneOf(['primary', 'secondary', 'outline', 'ghost']),
  size: PropTypes.oneOf(['lg', 'default', 'sm']),
  href: PropTypes.string
}

Button.defaultProps = {
  children: undefined,
  variant: 'primary',
  size: 'default',
  href: undefined
}

export default Button 